import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios'
import styles from '../Pages/ShowQuote.module.css'
import {useNavigate} from 'react-router-dom';

const ShowQuote = () => {

    const navigate = useNavigate();

    const params = useParams();
    // console.log(params.id);

    const [quote, setQuote] = useState({
        author: '',
        text: ''
    })

    async function fetchAQuote() {
        // const res = await axios.get(`https://quotes-app-qrwa.onrender.com/quotes/${params.id}`);
        const res = await axios.get(`https://quotes-app-qrwa.onrender.com/quotes/${params.id}`);
        // console.log(res);
        const { author, text } = res.data;
        setQuote({ author, text })
    }

    const deleteQuoteHandler = (id) => {
       
        // console.log(id);
        axios.delete(`https://quotes-app-qrwa.onrender.com/quotes/${params.id}`)
            .then(response => {
                // Handle success response
                console.log('Quote deleted successfully');
                // For example, you can navigate to another page after deletion
                navigate('/');
            })
            .catch(error => {
                // Handle error
                console.error('Error deleting quote:', error);
            });
    };
    


    const editQuoteHandler = (id) => {
        navigate(`/quotes/edit/${id}`);
    };


    useEffect(() => {
        fetchAQuote();
    }, []);


    return (
        <div className={styles['show-quote-form']}>
            <h1>{quote.author}</h1>
            <p>{quote.text}</p>
            <i className="bi bi-trash" onClick={() => deleteQuoteHandler(params.id)}></i>
            <i className="bi bi-pencil-square" onClick={() => editQuoteHandler(params.id)}></i>
        </div>
    )
}

export default ShowQuote